export const RESEND_DOC_WELCOME_EMAIL_MODAL_NAME =
  'RESEND_DOC_WELCOME_EMAIL_MODAL_NAME';
